
import { Component, Prop, Vue } from 'vue-property-decorator'

import { API } from '@/api/API'
import NavigateBack from '@/components/elements/NavigateBack.vue'
import FormInput from '@/components/forms/FormInput2.vue'
import { isValidationError } from '@/errors/ValidationError'
import { apiErrorMessageOrRethrow } from '@/errors/helpers'
import { reportFormValidity } from '@/helpers/Validation'

/**
 * A form with just one email address field and a submit button.
 * Re-used in Forgotten Password, Forgotten Membership and Resend Order.
 */

@Component({
  name: 'EmailSubmitForm',
  components: {
    FormInput,
    NavigateBack,
  },
})
export default class extends Vue {
  @Prop() submitText: string
  @Prop() postRoute: string
  @Prop({ default: () => {} }) extraPostParams: Dictionary
  @Prop({ default: false }) treat404AsSuccess: boolean
  @Prop({ default: '' }) custom404Message: string

  email: string | null = null
  submitting: boolean = false
  error: string | void | null = null
  success: boolean = false

  reportSuccess() {
    this.success = true
    this.$emit('success', this.email)
  }

  async submit() {
    this.error = null
    this.success = false
    try {
      await reportFormValidity(this.$refs.form as HTMLFormElement)
      this.submitting = true
      const body = { email: this.email, ...this.extraPostParams }
      await API.post(this.postRoute, { body })
      this.reportSuccess()
    } catch (e: unknown) {
      if (isValidationError(e)) {
        // Do nothing.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- API error response structure not typed for status access
      } else if ((e as any).response.status === 404 && (this.treat404AsSuccess || this.custom404Message)) {
        if (this.treat404AsSuccess) {
          this.reportSuccess()
        } else {
          this.error = this.custom404Message
        }
      } else {
        this.error = apiErrorMessageOrRethrow(e, 'validate_not_email')
      }
    } finally {
      this.submitting = false
    }
  }
}
